
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface DaysOfWeekSelectorProps {
  value: number[];
  onChange: (days: number[]) => void;
  disabled?: boolean;
}

const DAYS = [
  { value: 0, labelKey: 'classes.sunday', short: 'Sun' },
  { value: 1, labelKey: 'classes.monday', short: 'Mon' },
  { value: 2, labelKey: 'classes.tuesday', short: 'Tue' },
  { value: 3, labelKey: 'classes.wednesday', short: 'Wed' },
  { value: 4, labelKey: 'classes.thursday', short: 'Thu' },
  { value: 5, labelKey: 'classes.friday', short: 'Fri' },
  { value: 6, labelKey: 'classes.saturday', short: 'Sat' },
];

export function DaysOfWeekSelector({
  value,
  onChange,
  disabled,
}: DaysOfWeekSelectorProps) {
  const { t } = useTranslation();

  const handleDayToggle = (day: number) => {
    if (disabled) return;
    
    const newDays = value.includes(day)
      ? value.filter((d) => d !== day)
      : [...value, day].sort((a, b) => a - b);
    
    onChange(newDays);
  };

  return (
    <div className="grid grid-cols-7 gap-2">
      {DAYS.map((day) => (
        <div key={day.value} className="flex flex-col items-center space-y-2">
          <Checkbox
            id={`day-${day.value}`}
            checked={value.includes(day.value)}
            onCheckedChange={() => handleDayToggle(day.value)}
            disabled={disabled}
          />
          <Label
            htmlFor={`day-${day.value}`}
            className="cursor-pointer text-xs text-center"
          >
            {t(day.labelKey, day.short)}
          </Label>
        </div>
      ))}
    </div>
  );
}
